import $ from './el.JsModules.js';

class CollectionPage {
  'use strict';

  constructor() {
    if (CollectionPage.instance) {
      // This is a singleton, do not allow more than once instance
      return CollectionPage.instance;
    }
    CollectionPage.instance = this;

    this.promotionInsertOffset = 0;

    const boostProductGrid = $('.boost-sd__filter-product-list');

    if (boostProductGrid.length > 0) {
      if (boostWidgetIntegration) {
        // Note that the NAMES of the methods are important here (which is kind of mad, but that's how it works e.g. afterAddToCart)
        // These functions are called by the Boost customization.js which you can access via the Boost App Shopify Code Editor
        // boostWidgetIntegration.regisCustomization(this.afterAddToCart);
        // boostWidgetIntegration.regisCustomization(this.afterRender);

        this.fetchGridPromotions();
      }
    }

    this.windowWidth = elabs.windowElement.width();
    elabs.documentElement.on('WINDOW_RESIZED_EVENT', (newWidth, newHeight) => {
      if (this.windowWidth !== newWidth) {
        this.windowWidth = newWidth;
        // Recalculate the promotions positions
        if (this.promotions && this.promotions.length > 0) {
          this.promotionInsertOffset = 0; // reset the offset so we can reinsert promotions
          $('.el-product-grid-promotion').remove();
          this.populateGridWithPromotions();
        }
      }
    });
  }

  async fetchGridPromotions() {
    const resText = await fetch('/pages/contact?view=ajax-one-world-product-grid-promotions');
    this.promotionsResponse = await resText.text();

    this.initialiseGridPromotions();
  }

  initialiseGridPromotions() {
    if (!this.promotionsResponse) {
      return;
    }

    if ($('.boost-sd__product-list').length === 0) {
      requestTimeout(() => {
        this.initialiseGridPromotions();
      }, 300);
    }

    if (!this.promotions) {
      const isTradeCustomer = window.customer.is_trade_customer;

      // get promotions that are relevant to the current customer type
      this.promotions = $(this.promotionsResponse)
        .filter('.el-product-grid-promotion')
        .filter(function () {
          const gridPromotionEl = $(this);
          if (!isTradeCustomer && gridPromotionEl.attr('data-show-to-retail-customers') === 'true') {
            return true;
          }

          if (isTradeCustomer && gridPromotionEl.attr('data-show-to-trade-customers') === 'true') {
            return true;
          }

          return false;
        });

      // clear the response to free up memory
      this.promotionsResponse = undefined;
    }

    if (this.promotions.length === 0) {
      return; // there were no promotions specified
    }

    this.promotions = this.promotions.toArray();

    this.promotionGridOffset = localStorage.getItem('el-product-grid-promotion-offset');
    if (this.promotionGridOffset) {
      this.promotionGridOffset = parseInt(this.promotionGridOffset, 10);
      this.promotions.rotate(this.promotionGridOffset);
    } else {
      this.promotionGridOffset = 0;
    }

    if (this.promotions.length === 0) {
      console.log('No promotions found');
      return;
    }

    this.populateGridWithPromotions();
  }

  populateGridWithPromotions() {
    if (!this.promotions) {
      return; // no promotions to insert (or none ready yet)
    }

    const productGridChildren = $('.boost-sd__product-list').children();
    if (!productGridChildren || productGridChildren.length === 0) {
      requestTimeout(() => {
        this.populateGridWithPromotions();
      }, 500);
      return;
    }

    // default 1 columns
    const random = Math.random() < 0.5;
    let position = random ? [19, 50, 87, 90] : [17, 46, 89, 95];

    const windowWidth = elabs.windowElement.width();

    if (windowWidth >= 2720) {
      // 8 columns
      position = random ? [6, 36, 54, 72] : [9, 32, 72, 97];
    } else if (windowWidth >= 2380) {
      // 7 columns
      position = random ? [11, 21, 44, 75] : [12, 38, 56, 74];
    } else if (windowWidth >= 2040) {
      // 6 columns
      position = random ? [14, 30, 48, 68] : [15, 31, 48, 69];
    } else if (windowWidth >= 1700) {
      // 5 columns
      position = random ? [10, 31, 53, 71] : [11, 30, 53, 70];
    } else if (windowWidth >= 1360) {
      // 4 columns
      position = random ? [13, 42, 58, 80] : [12, 42, 58, 81];
      // position = [1, 4, 16, 21]; // For testing
    } else if (windowWidth >= 1020) {
      // 3 columns
      position = random ? [12, 37, 72, 91] : [13, 36, 73, 90];
    } else if (windowWidth >= 680) {
      // 2 columns
      position = random ? [22, 50, 80, 100] : [22, 60, 82, 102];
    }

    for (this.promotionInsertOffset; this.promotionInsertOffset < position.length; this.promotionInsertOffset++) {
      if (this.promotions.length <= this.promotionInsertOffset) {
        break; // no more promotions to insert
      }
      const gridItem = productGridChildren.eq(position[this.promotionInsertOffset] - this.promotionInsertOffset);
      if (gridItem.length > 0) {
        console.log('Inserting promotion at position', position[this.promotionInsertOffset]);
        gridItem.before(this.promotions[this.promotionInsertOffset]);
        localStorage.setItem(
          'el-product-grid-promotion-offset',
          this.promotionGridOffset + this.promotionInsertOffset + 1,
        );
      } else {
        console.log('No grid item found at position', position[this.promotionInsertOffset]);
        break; // no more room to insert further promotions
      }
    }

    $('.el-product-grid-promotion__video').each(function (index, element) {
      const video = $(element);
      const videoContainer = video.parent();
      if (video.height() < videoContainer.height()) {
        video.css('height', 'calc(100% + 2px)');
        video.css('width', 'auto');
      }
    });
  }

  initialiseDiagonalScrollingText() {
    // Initialise the diagonal scrolling texts
    $('.el-product-card__diagonal-scrolling-text:not(.el-diagonal-scrolling-text--initialised)').each(
      function (index, element) {
        const marqueeElement = $(element);
        const marqueeContent = marqueeElement.text();
        marqueeElement.html('');
        new SuperMarquee(marqueeElement[0], {
          content: marqueeContent,
          speed: '0.03', // 0.0125 - 0.2... larger is faster
          pauseonhover: false,
        });

        marqueeElement.addClass('el-diagonal-scrolling-text--initialised');
      },
    );
  }

  boostAfterRender(data) {
    _.debounce(() => {
      // we need to wait a moment for the grid to fully initialise, otherwise things don't work
      // Note we need to use the singleton reference here because afterRender cannot seem to be bound to this instance
      elabs.CollectionPage.initialiseDiagonalScrollingText();
      setTimeout(() => {
        elabs.Bootstrap.initialiseTooltips('.boost-sd__product-list [data-tippy-content]');
      }, 1000);

      if (elabs.CollectionPage.promotionInsertOffset > 0) {
        if ($('.el-product-grid-promotion').length === 0) {
          // the grid has been re-rendered and the promotions have been removed, need to reinsert from the start
          elabs.CollectionPage.promotionInsertOffset = 0;
        }
      }
      elabs.CollectionPage.populateGridWithPromotions();
    }, 600)();
  }

  boostAfterAddToCart(_, data) {
    let productTitle = data?.response?.items?.[0]?.product_title;
    if (productTitle) {
      productTitle = `<strong>${productTitle}</strong>`;
    } else {
      productTitle = 'item';
    }
    elabs.Utils.showToast(`The ${productTitle} has been added to your cart`, window.elStrings.quickAddToCartIconUrl);

    // Trigger a refetch of the cart contents
    const cartItemsElement = document.querySelector('cart-drawer-items');
    if (cartItemsElement) {
      cartItemsElement.onCartUpdate();
    }
  }
}

// Initialise all Popovers
elabs.onJavascriptReady(function () {
  // boringly we use a singleton here because the boost library method `regisCustomization` cannot be bound to `this` instance
  elabs.CollectionPage = new CollectionPage();
});
